import requestAdmin from "@/utils/requestAdmin.js";

// 获取模块列表
export function getModuleList() {
  return requestAdmin({
    url: `/module/list`,
    method: "get",
  });
}

// 模块排序
export function moduleListSort(data) {
  return requestAdmin({
    url: `/module/sort`,
    method: "post",
    data,
  });
}

// 模块新增修改
export function moduleAddOrEdit(data) {
  return requestAdmin({
    url: `/module`,
    method: "post",
    data,
  });
}

// 模块新增修改
export function moduleDelete(id) {
  return requestAdmin({
    url: `/module/${id}`,
    method: "delete",
  });
}

// 表单搜索关联模块
export function formSearch(keyword) {
  return requestAdmin({
    url: `form/search`,
    method: "get",
    params: {
      keyword,
    },
  });
}

// 移动表单
export function formMove(data) {
  return requestAdmin({
    url: `form-group/sort`,
    method: "put",
    data,
  });
}

// 移动表单
export function recentUse() {
  return requestAdmin({
    url: `form/recentUse`,
    method: "get",
  });
}

// 模板列表
export function templatePage(data) {
  return requestAdmin({
    url: `template/page`,
    method: "post",
    data,
  });
}

// 数据日志列表
export function dataLogPage(data) {
  return requestAdmin({
    url: `data-log/page`,
    method: "post",
    data,
  });
}

// 应用日志列表
export function dataLogModulePage(data) {
  return requestAdmin({
    url: `data-log/module/page`,
    method: "post",
    data,
  });
}

// 新增或修改模板
export function updateOrAddTemplate(data) {
  return requestAdmin({
    url: `template`,
    method: "post",
    data,
  });
}

// 新增或修改模板
export function getSolutionPage(data) {
  return requestAdmin({
    url: `solution/page`,
    method: "post",
    data,
  });
}

// 删除解决方案
export function deleteSolution(id) {
  return requestAdmin({
    url: `solution/${id}`,
    method: "delete",
  });
}


// 新增或修改解决方案
export function addOrUpdateSolution(data) {
  return requestAdmin({
    url: `solution`,
    method: "post",
    data,
  });
}